import { Partial } from '@40seas/entities/common';
import { CreateInvoiceDto } from './create.invoice.dto';

export class UpdateInvoiceDto extends Partial(CreateInvoiceDto) {}
